module.exports = "<img class=\"platter\" [src]=\"platterImage\" />\n<img class=\"number\" [src]=\"getNumberImage()\" />"